import React, { useState } from "react";
import S2cReport from "./S2cReport";
import S2dReport from "./S2dReport";
import S2eReport from "./S2eReport";

type TabType = "s2c" | "s2d" | "s2e";

const S2ReportPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>("s2c");

  const tabs = [
    {
      id: "s2c" as TabType,
      label: "Chi tiết doanh thu - chi phí (S2c)",
      description: "Theo dõi doanh thu, chi phí và tính lãi/lỗ",
    },
    {
      id: "s2d" as TabType,
      label: "Vật liệu - hàng hóa (S2d)",
      description: "Theo dõi nhập - xuất - tồn kho",
    },
    {
      id: "s2e" as TabType,
      label: "Chi tiết tiền (S2e)",
      description: "Theo dõi dòng tiền thu - chi",
    },
  ];

  return (
    <div className="p-6 space-y-6">
      <div>
        <p className="text-sm text-gray-500 uppercase">Báo cáo S2-HKD</p>
        <h1 className="text-2xl font-semibold text-gray-900">
          Sổ chi tiết sản phẩm, hàng hóa, dịch vụ
        </h1>
        <p className="text-sm text-gray-600 mt-1">
          Báo cáo S2 theo TT152 bao gồm 3 sổ: doanh thu-chi phí, vật liệu-hàng
          hóa, và tiền
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${
                  activeTab === tab.id
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              <div>
                <div>{tab.label}</div>
                <div className="text-xs font-normal mt-0.5 text-gray-500">
                  {tab.description}
                </div>
              </div>
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === "s2c" && <S2cReport />}
        {activeTab === "s2d" && <S2dReport />}
        {activeTab === "s2e" && <S2eReport />}
      </div>
    </div>
  );
};

export default S2ReportPage;
